import {
  trigger,
  transition,
  style,
  query,
  animate,
} from '@angular/animations';

/**
 * Subtle fade + "breath" (gentle scale) transition applied whenever the
 * router swaps the active component. The entering view fades in while easing
 * up to full scale, giving a soft breathing feel on every page change /
 * redirect. Enter-only so there is no overlap or layout jump between views.
 */
export const routeFade = trigger('routeFade', [
  transition('* => *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'scale(0.985)' }),
        animate(
          '320ms ease-out',
          style({ opacity: 1, transform: 'scale(1)' })
        ),
      ],
      { optional: true }
    ),
  ]),
]);
